
import ChevronRight from "/public/images/icons/chevronRight.svg?react";
import { motion } from "framer-motion";

export default function CartProductCard({ product, active, setActive, children }) {
  
  const gradient =  
    product?.BandVenueColour === "Red"
      ? "#A4123F"
    : product?.BandVenueColour === "Blue"
      ? "#1877D3"
    : product?.BandVenueColour === "Grey"
      ? "#727272"
    : product?.BandVenueColour === "Black"
      ? "#101820"
    : product?.BandVenueColour === "Yellow"
      ? "#EAAA00"
    : "#F8F8F8";

    return (
      <>
        <div
          className={`flex flex-col justify-between ${
            active ? "border-[#EAAA00]" : "border-[#E3E3E3]"
          } bg-white border rounded-[8px] py-[12px] px-[10px]`}
          data-testid="dropdown-container"
        >
          <div
            className={`flex justify-between min-w-full`}
            onClick={() => setActive(!active)}
          >
            <div className="flex flex-row items-center gap-x-[20px]">
              <div className="flex flex-col w-[50px] relative items-center align-middle justify-center">
                <div className="h-[45px] w-[45px] my-[10px] mx-[10px]">
                  <div
                    className={`border-[1px] border-[#E3E3E3] rounded-[4px] h-full`}
                    style={{
                      background: `${gradient}`,
                    }}
                  >
                    <div
                      className={`flex flex-col h-full w-full rounded-[4px]`}
                      style={{
                        background: `linear-gradient(134.5deg, rgba(255,255,255, 0.1) 0%, rgba(255,255,255, 0.1) 50%, ${gradient} 50.1%, ${gradient} 100%)`,
                      }}
                    />
                  </div>
                </div>
                <div className="flex flex-col items-center h-full w-max absolute top-[5px] left-[52%] transform -translate-x-1/2 ">
                  <img
                    src={product?.BandImage || product?.Org3dImageURL}
                    alt="band"
                    className="max-w-[63px]"
                  />
                </div>
              </div>
    
              <div className="flex flex-col align-middle justify-center">
                <p className="text-sportsBlack font-normal text-[12px] capitalize">
                  {product?.ParticipantName}
                </p>
                <p className="text-sportsBlack font-semibold text-[13px] capitalize">
                  {product?.OrgPartnerFriendlyName} Band ({product?.BandVenueColour})
                </p>
                <p className="text-sportsDarkGrey text-[12px]">
                  (x{product?.Quantity}) £{product.OrgPriceFormatted} Each
                </p>
              </div>
            </div>
          <div className="flex flex-col justify-center items-center align-middle">
            <ChevronRight
              data-testid="dropdown-icon"
              className={`${
                active ? "fill-[#EAAA00] -rotate-90" : "fill-black rotate-90"
              } transition-all cursor-pointer`}
            />
          </div>
          </div>
        <motion.div
          animate={{
            height: active ? "auto" : 0,
            marginTop: active ? "24px" : 0,
          }}
          initial={{ height: 0, marginTop: 0 }}
          transition={{ duration: 0.5 }}
          className={`overflow-hidden border-dashed border-t border-transparent ${
            active && "!border-[#E3E3E3]"
          }`}
          data-testid="dropdown-content"
          >
          <div className="flex flex-col gap-0 pt-[24px]">{children}</div>
        </motion.div>
      </div>
      </>
    );

}

